"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const formik_1 = require("formik");
const InputField_1 = __importDefault(require("../../forms/InputField"));
const Button_1 = __importDefault(require("../../forms/Button"));
const react_router_dom_1 = require("react-router-dom");
const api_1 = require("../../api");
const errorNotification_1 = require("../../errorNotification");
const react_helmet_1 = __importDefault(require("react-helmet"));
const SelectField_1 = __importDefault(require("../../forms/SelectField"));
const AddEdit = ({ history, match, ...props }) => {
    const { id } = match.params;
    const isAddMode = !id;
    const usersApi = new api_1.UserApi();
    const rolesApi = new api_1.RoleApi();
    const companiesApi = new api_1.CompanyApi();
    const [roles, setRoles] = (0, react_1.useState)([]);
    const [companies, setCompanies] = (0, react_1.useState)([]);
    let initialValues = {
        name: '',
        email: '',
        active: false,
        password: '',
        role: '',
        company_id: '',
    };
    function onSubmit(fields, { setErrors, setStatus, setSubmitting }) {
        setStatus();
        if (isAddMode) {
            createUser(fields, setSubmitting, setErrors);
        }
        else {
            updateUser(id, fields, setSubmitting, setErrors);
        }
    }
    function createUser(fields, setSubmitting, setErrors) {
        usersApi.create(fields)
            .then(() => {
            (0, errorNotification_1.notify)('success', 'Benutzer erstellt.');
            history.push('.');
        })
            .catch((error) => {
            if (error.response.status === 422) {
                setErrors(error.response.data.errors);
            }
            else {
                (0, errorNotification_1.notifyError)(error.response.data.message);
            }
            setSubmitting(false);
        });
    }
    function updateUser(id, fields, setSubmitting, setErrors) {
        usersApi.update(id, fields)
            .then(() => {
            (0, errorNotification_1.notify)('success', 'Benutzer aktualisiert.');
            history.push('..');
        })
            .catch(error => {
            if (error.response.status === 422) {
                setErrors(error.response.data.errors);
            }
            else {
                (0, errorNotification_1.notifyError)(error.response.data.message);
            }
            setSubmitting(false);
        });
    }
    return (react_1.default.createElement("div", { className: "container max-w-5xl" },
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, isAddMode ? 'Neuer Benutzer' : 'Benutzer')),
        react_1.default.createElement("div", { className: "flex-1 min-w-0 my-4" },
            react_1.default.createElement("h2", { className: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate" }, isAddMode ? 'Neuer Benutzer' : 'Benutzer')),
        react_1.default.createElement("div", { className: "" },
            react_1.default.createElement("div", { className: "shadow sm:rounded-md sm:overflow-hidden" },
                react_1.default.createElement("div", { className: "bg-white py-6 px-4 sm:p-6" },
                    react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, onSubmit: onSubmit }, ({ values, isSubmitting, setFieldValue }) => {
                        const [user, setUser] = (0, react_1.useState)({});
                        (0, react_1.useEffect)(() => {
                            if (!isAddMode) {
                                // get user and set form fields
                                usersApi.get(id).then((data) => {
                                    const { item } = data;
                                    const fields = ['name', 'email', 'active', 'role', 'company_id'];
                                    fields.forEach(field => setFieldValue(field, item[field], false));
                                    setUser(item);
                                });
                            }
                            const fetchInitial = async () => {
                                const data = await rolesApi.index();
                                const { items } = await companiesApi.index();
                                setRoles(data.items);
                                setCompanies(items);
                            };
                            fetchInitial();
                        }, []);
                        return (react_1.default.createElement(formik_1.Form, null,
                            react_1.default.createElement("div", { className: 'space-y-6' },
                                react_1.default.createElement(InputField_1.default, { name: "name", type: "text", label: "Name", placeholder: "Name" }),
                                react_1.default.createElement(InputField_1.default, { name: "email", type: "text", label: "Email", placeholder: "E-Mail" }),
                                react_1.default.createElement(InputField_1.default, { name: "password", type: "password", label: "Passwort", placeholder: "Passwort" }),
                                react_1.default.createElement("div", { className: "flex items-center" },
                                    react_1.default.createElement(formik_1.Field, { type: "checkbox", onChange: () => setFieldValue("active", !values.active), name: "active", id: "active", className: "checkboxx" }),
                                    react_1.default.createElement("label", { htmlFor: "active", className: "ml-2 block text-sm text-gray-900" }, "Aktiv")),
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement(SelectField_1.default, { label: 'Rolle', options: roles.map(role => role.name), name: "role", placeholder: 'Auswählen…' })),
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement(SelectField_1.default, { label: 'Firma', options: companies.map((c) => ({ value: c.id, label: c.name })), name: "company_id", placeholder: 'Auswählen…' })),
                                react_1.default.createElement(Button_1.default, { type: "submit", size: 'md', disabled: isSubmitting }, "Speichern"),
                                react_1.default.createElement(react_router_dom_1.Link, { to: `/users`, className: "ml-4 link-button --secondary" }, "Abbrechen"))));
                    }))))));
};
exports.default = AddEdit;
